module.exports = __webpack_public_path__ + "static/assets/2e802244274d46cd70ac5a0d552b6a12.png";